// extracted by mini-css-extract-plugin
export var actions = "_pr-5";
export var assistantBubble = "_pr-3";
export var assistantRow = "_pr-6";
export var bubble = "_pr-0";
export var humanAvatar = "_pr-4";
export var inlineToolCard = "_pr-1";
export var userBubble = "_pr-2";